import apiSlice from '../api/api.slice';
import { CNCVariantI } from './cncVariant';

export const cncModel = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCNCVariants: builder.query<
      CNCVariantI[],
      {
        modelIdList?: string[];
        variantIdList?: string[];
      }
    >({
      query: ({ modelIdList, variantIdList }) => ({
        url: `/api/v1/cncVariant/getVariants${
          modelIdList
            ? `?${modelIdList.map((id) => `modelId=${id}`).join('&')}`
            : ''
        }${
          variantIdList
            ? `${modelIdList ? '&' : '?'}${variantIdList.map((id) => `variantId=${id}`).join('&')}`
            : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: { variants: CNCVariantI[] }) =>
        response.variants,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['cncVariant'],
  endpoints: {
    providesTags: ['cncVariant'],
  },
});

export const { useGetCNCVariantsQuery, useLazyGetCNCVariantsQuery } = cncModel;
